module.exports = __webpack_public_path__ + "images/feature/20190510-2ab1f8246c1f9da5ec631c64afd8a8ea.svg";